import { render } from "./BasicTitle.vue?vue&type=template&id=9bf93aaa&scoped=true"
import script from "./BasicTitle.vue?vue&type=script&lang=js"
export * from "./BasicTitle.vue?vue&type=script&lang=js"

import "./BasicTitle.vue?vue&type=style&index=0&id=9bf93aaa&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-9bf93aaa"

export default script